module.exports = __webpack_public_path__ + "static/top-bkg-f61fbbd76f4378a91fa13b2eb767103e.png";